const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const OBJECT_ID_PATTERN = /^[0-9a-f]{24}$/i;

export function isOpaqueActorIdentifier(value, actorId = '') {
  const text = String(value || '').trim();
  const id = String(actorId || '').trim();
  return Boolean(text && ((id && text === id) || UUID_PATTERN.test(text) || OBJECT_ID_PATTERN.test(text)));
}

function readableIdentity(value, actorId = '') {
  const text = String(value || '').trim();
  return text && !isOpaqueActorIdentifier(text, actorId) ? text : '';
}

export function auditActorLabel({
  name,
  email,
  id,
  fallback = 'Staff member',
} = {}) {
  return readableIdentity(name, id) || readableIdentity(email, id) || fallback;
}

export function applicationNoteAuthorLabel(note = {}) {
  return auditActorLabel({
    // `author` is what notes written before author_name carry. It is a name
    // candidate like any other, and goes through the same guard -- a legacy
    // note whose author was stored as an actor id must not show it as a name.
    name: note.author_name || note.author,
    email: note.author_email,
    id: note.author_user_id,
    fallback: note.author_user_id ? 'Staff member' : 'System',
  });
}

export function applicationNoteEditorLabel(note = {}) {
  return auditActorLabel({
    name: note.edited_by_name,
    email: note.edited_by_email,
    id: note.edited_by_user_id,
  });
}
